import React from 'react';
import {
  Box,
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { deleteGroup } from '../../store/api_funcs';
import { useStores } from '../../store/store_context';
import { useState } from 'react';
import GroupsSearch from '../groups_autocomplete';

const GroupDeleteForm = ({
  updatePanelsTable,
  groups,
  updateGroups,
  defaultValue = '',
}) => {
  const { pageStore } = useStores();
  const [groupId, setGroupId] = useState(null);
  const handleSubmit = async (values, actions) => {
    await deleteGroup(groupId, pageStore.token);
    await updateGroups();
    await updatePanelsTable();
    console.log('Отправленные данные:', values);
    actions.setSubmitting(false);
  };

  return (
    <VStack width={'100%'} align={'flex-start'}>
      <Formik initialValues={{}} onSubmit={handleSubmit}>
        {({ isSubmitting }) => (
          <Form style={{ width: '100%' }}>
            <Text>Начните вводить название группы</Text>
            <GroupsSearch
              setResult={setGroupId}
              items={(groups || []).map(elem => {
                return {
                  id: elem.group_id,
                  name: elem.group_name,
                };
              })}
              defaultValue={defaultValue}
            />

            <Box mt={4}>
              <Button
                type="submit"
                isLoading={isSubmitting}
                isDisabled={!groupId}
                backgroundColor={'#7B79FF'}
                _hover={{ backgroundColor: '#4945FF' }}
                color="white"
              >
                Удалить группу
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </VStack>
  );
};

export default GroupDeleteForm;
